import type { Tile, Object } from 'tiled-tmj-typedefs';
import { Spine } from 'pixi-spine';
import { Sprite, Container } from 'pixi.js';
import { Buildings } from '~/utils/constants';

export interface InteractiveObject {
  tileObject: Tile | Object;
  spriteElement: Spine | Sprite;
}

export interface IObject {
  gid: number;
  height: number;
  id: number;
  name: string;
  rotation: number;
  type: string;
  visible: boolean;
  width: number;
  x: number;
  y: number;
  properties: IProperties[];
}

type PropertyName = 'buildingKey' | 'buildingName' | 'buildingHash' | 'isClickable' | 'isHoverable' | 'tintColor';

interface IProperties {
  name: PropertyName;
  type: string;
  value: Buildings;
}

export enum TiledButtons {
  SeasonCup = 'season_cup',
  SeasonChest = 'season_chest',
  Story = 'story',
  Storage = 'storage',
  Seller = 'sellerIcon',
  Halloween = 'halloweenEvent',
  Dex = 'dex',
  Mute = 'mute',
  Volume = 'volume'
}

export enum BuildingTextures {
  SellerClosed = 'sellerClosed',
  SellerOpened = 'sellerOpened'
}

export interface TiledButton {
  key: TiledButtons;
  container: Container;
}

export enum ButtonBG {
  primary = 'primary',
  highlighted = 'highlighted',
  highlightedHover = 'highlightedHover',
  halloween = 'halloweenBackground',
  halloweenHover = 'halloweenBackgroundHover'
}
